export default "__VITE_ASSET__p4dv7UJ9__ 1036w, __VITE_ASSET__E2o7JnHc__ 767w, __VITE_ASSET__932Rh7ML__ 500w";